// import { useGlobalLocation } from "./LocationContext.js";
export const urlTitle2 = (title) => {
  const cyrilic = ["č", "ć", "ž", "š", "đ", ",", ":", "-", "?", "!", "."];
  const replArray = ["c", "c", "z", "s", "dj", "", "", "", "", "", ""];
  let regex = /--/gi;
  let url_title = title
    .toLowerCase()
    .split("")
    .map((x) => {
      return cyrilic.indexOf(x) === -1 ? x : replArray[cyrilic.indexOf(x)];
    })
    .join("")
    .split(" ")
    .join("-")
    .replace(regex, "-");
  return url_title;
};
export const id2 = (pathPart) => {
  const labels = {
    subvencije: "Subvencije",
    "produktna-berza": "Produktna berza",
    vinoteka: "Vinoteka",
  };
  // console.log("PathPart", pathPart);

  if (pathPart[1] === "vinoteka") {
    return labels[pathPart[1]] || null;
  } else {
    return labels[pathPart[2]] || null;
  }
};
export const setSource = (item) => {
  if (Array.isArray(item)) {
    return `Autor: ${item[1]}`;
  } else {
    return `Izvor: ${item}`;
  }
};

export const getPreUrlTitle = (item, allC, cat = false) => {
  const found = allC.find((e) => urlTitle2(e.title) === urlTitle2(item.category));
  const route = found?.route;
  return route ? `${route}${cat ? "" : urlTitle2(item.title) + "/"}` : "";
};

export const sortByDate = (item1, item2) => {
  const date1 = new Date(item1.modified || item1.time2);
  const date2 = new Date(item2.modified || item2.time2);
  return date2 - date1;
};
